import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FullPageSpinner } from 'common/components';
import { getFetchingStatus, getUpstreamClient } from '../selectors/organisationSelectors';
import { UpstreamDetails } from '../components/UpstreamDetails';
import { getUserOrganisationId } from 'features/user/selectors/userSelectors';
import { getUpstreamClientRequest } from '../actions/organisationActions';
import { CreateClientUpstream } from '../components/CreateClientUpstream';

export const UpstreamDetailsContainer = () => {
    const dispatch = useDispatch();

    const activeUserOrganisationId = useSelector(getUserOrganisationId);
    const upstreamClientSettings = useSelector(getUpstreamClient);
    const fetchingStatus = useSelector(getFetchingStatus);

    useEffect(() => {
        if (activeUserOrganisationId) {
            dispatch(getUpstreamClientRequest(activeUserOrganisationId));
        }
    }, []);

    const renderContent = () => {
        if (fetchingStatus === 'inProgress' && !upstreamClientSettings) {
            return <FullPageSpinner />;
        }

        if (fetchingStatus === 'failed' && !upstreamClientSettings) {
            return (
                <CreateClientUpstream
                    key={'create-upstream'}
                    dispatch={dispatch}
                    organisationId={activeUserOrganisationId}
                />
            );
        }

        if (upstreamClientSettings) {
            return (
                <UpstreamDetails
                    key={upstreamClientSettings.id}
                    dispatch={dispatch}
                    upstreamClientSettings={upstreamClientSettings}
                    organisationId={activeUserOrganisationId}
                />
            );
        }

        return null;
    };

    return renderContent();
};
